import "core-js/modules/es.function.name";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import styles from './Icon.scss';

function Icon(_ref) {
  var name = _ref.name,
      size = _ref.size,
      color = _ref.color,
      className = _ref.className,
      xlinkHref = _ref.xlinkHref,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("svg", {
    className: classnames(styles.icon, className, styles["color-".concat(String(color))], _defineProperty({}, styles["size-".concat(String(size))], size !== null)),
    focusable: false,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: xlinkHref || "#icon-".concat(name)
  }));
}

Icon.defaultProps = {
  size: 'medium',
  color: 'icon',
  className: '',
  xlinkHref: undefined
};
export default Icon;